module.exports = __webpack_public_path__ + "img/1Reihe_4.fe2fdd1a.jpg";